import { Body, ExternalLinkIcon } from '@postidigital/posti-components/build/brand'
import React from 'react'

import { StyledLinkWithExternalIcon } from '../../views/registration/registration.styles'

export const checkboxLabel = (label: string, description?: string) => {
  const linkRegex = /\(LINK\|\s*(https?:\/\/[^\s]+)\s*\|\s*([^\)]+)\)/g
  const parts: JSX.Element[] = []

  // Process label
  let labelLastIndex = 0
  let labelMatch
  while ((labelMatch = linkRegex.exec(label)) !== null) {
    if (labelMatch.index > labelLastIndex) {
      const textPart = label.substring(labelLastIndex, labelMatch.index)
      parts.push(<span key={`label-${labelLastIndex}`}>{textPart}</span>)
    }
    parts.push(
      <span key={`label-link-${labelMatch.index}`}>
        <StyledLinkWithExternalIcon
          icon={ExternalLinkIcon}
          target="_blank"
          size="xxs"
          href={labelMatch[1]}
          svgMargin="0px 0.125rem 0rem 0.5rem"
        >
          {labelMatch[2]}
        </StyledLinkWithExternalIcon>
      </span>
    )
    labelLastIndex = linkRegex.lastIndex
  }
  if (labelLastIndex < label.length) {
    const textPart = label.substring(labelLastIndex)
    parts.push(<span key={`label-${labelLastIndex}`}>{textPart}</span>)
  }

  // Process description if provided
  if (description) {
    const descriptionParts: (string | JSX.Element)[] = []
    let lastIndex = 0
    let match

    while ((match = linkRegex.exec(description)) !== null) {
      if (match.index > lastIndex) {
        const textPart = description.substring(lastIndex, match.index)
        descriptionParts.push(textPart)
      }
      descriptionParts.push(
        <StyledLinkWithExternalIcon
          style={{ border: '0px' }}
          icon={ExternalLinkIcon}
          target="_blank"
          size="xxs"
          svgMargin="0px 0.125rem 0rem 0.5rem"
          href={match[1]}
        >
          {match[2]}
        </StyledLinkWithExternalIcon>
      )
      lastIndex = linkRegex.lastIndex
    }
    if (lastIndex < description.length) {
      const textPart = description.substring(lastIndex)
      descriptionParts.push(textPart)
    }

    const paragraphs = descriptionParts.reduce((acc, part) => {
      if (typeof part === 'string') {
        const lines = part.split('\n')
        lines.forEach((line, index) => {
          if (index === 0 && acc.length > 0) {
            acc[acc.length - 1].push(line)
          } else {
            acc.push([line])
          }
        })
      } else {
        if (acc.length === 0) {
          acc.push([part])
        } else {
          acc[acc.length - 1].push(part)
        }
      }
      return acc
    }, [] as (string | JSX.Element)[][])

    parts.push(
      <Body size={'Five'} key="description" style={{ marginTop: '8px', marginLeft: '0px', lineHeight: '1.0' }}>
        {paragraphs.map((paragraph, index) => (
          <p key={`desc-p-${index}`}>
            {paragraph.map((part, partIndex) => (
              <React.Fragment key={partIndex}>{part}</React.Fragment>
            ))}
          </p>
        ))}
      </Body>
    )
  }

  return React.createElement('span', { style: { display: 'block', fontWeight: 300 } }, parts)
}
